export const drugTypes = {
  G: {
    key: "G",
    title: "G - Generic Substitution",
    description:
      "The pharmacy is requesting the provider's permission to dispense a generic version of the prescribed medication, in cases where substitution is restricted by the original prescription or local regulations.",
  },
  P: {
    key: "P",
    title: "P - Prior Authorization Required",
    description:
      "The pharmacy is requesting the provider to review the prescribed medication and obtain prior authorization from the patient's insurance or payer before it can be dispensed.",
  },
  T: {
    key: "T",
    title: "T - Therapeutic Interchange",
    description:
      "The pharmacy is requesting the provider to approve a therapeutic alternative to the original prescription, such as a formulary-approved medication or a change in days' supply (e.g., from 30 to 90 days).",
  },
  D: {
    key: "D",
    title: "D - Drug Use Evaluation (DUE)",
    description:
      "The pharmacy is requesting the provider to authorize a modification to the patient’s medication therapy, such as adjusting the dosage or switching to a medication with fewer adverse effects.",
  },
  S: {
    key: "S",
    title: "S - Script Clarification",
    description:
      "The pharmacy is asking the provider to clarify details of the prescription, such as drug name, dosage instructions (Sig), or the number of days the supply should cover.",
  },
  OS: {
    key: "OS",
    title: "OS - Out of Stock",
    description:
      "The pharmacy is informing the provider that the prescribed medication is out of stock and is requesting authorization to substitute it with an available alternative.",
  },
  RM: {
    key: "RM",
    title: "RM - REMS (Risk Evaluation)",
    description:
      "The pharmacy requires additional information from the provider to comply with REMS (Risk Evaluation and Mitigation Strategy) requirements related to the prescribed medication. (Note: Not currently supported by Surescripts.)",
  },
  U: {
    key: "U",
    title: "U - Prescriber Authorization",
    description:
      "The pharmacy is requesting verification or authorization from the provider, such as confirming their DEA number or prescription benefit plan enrollment, to proceed with fulfilling the prescription. Only “Denied” or “Validated” responses are accepted.",
  },
};
